import type { EntrySlice } from '../types'
import { isJournalEntry } from './guard'
import { JournalRow } from './row'
import type { JournalEntry } from './meta'
import type { JournalDraft } from './write-spec'

/**
 * The journal kind's adapter behind the entry-kind seam.
 *
 * `editForm` is `null`: the journal row edits inline, in its own body, rather than swapping in a
 * separate component the way the task row does.
 */
export const journalSlice: EntrySlice<JournalEntry, JournalDraft> = {
  guard: isJournalEntry,
  row: JournalRow,
  editForm: null,
}
